import { render, staticRenderFns } from "./RulesModal.vue?vue&type=template&id=60688ffe&scoped=true"
import script from "./RulesModal.vue?vue&type=script&lang=js"
export * from "./RulesModal.vue?vue&type=script&lang=js"
import style0 from "./RulesModal.vue?vue&type=style&index=0&id=60688ffe&prod&scoped=true&lang=scss"
import style1 from "./RulesModal.vue?vue&type=style&index=1&id=60688ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60688ffe",
  null
  
)

export default component.exports